export default "__VITE_ASSET__BYvOgyj3__"